/* 🤖 this file was generated by svg-to-ts */
export const DfIconLockOpen12: {
  name: 'lock-open-12';
  data: string;
} = {
  name: 'lock-open-12',
  data: `<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M5 5h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 1-1.732V3a3 3 0 0 1 3-3c1.37 0 2.284.648 2.745 1.944A.79.79 0 0 1 8 3h-.31a1 1 0 0 1-.874-.513C6.636 2.162 6.363 2 6 2c-.552 0-1 .56-1 1.25V5z" fill-rule="evenodd"/></svg>`
};
